<script>
import AdvBaseControl from '@advisor/components/common/AdvBaseControl.vue';
import {PROP} from '@advisor/util/constants';

export default {
  name: 'AdvButton',
  extends: AdvBaseControl,
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    onClick: {
      type: Function,
      required: false,
      default: null,
    },

    // v-btn params
    absolute: {...PROP.BOOLEAN_TYPE, default: false},
    activeClass: {...PROP.STRING_TYPE, default: 'v-btn--active'},
    append: {...PROP.BOOLEAN_TYPE, default: false},
    block: {...PROP.BOOLEAN_TYPE, default: false},
    bottom: {...PROP.BOOLEAN_TYPE, default: false},
    depressed: {...PROP.BOOLEAN_TYPE, default: false},
    exact: {...PROP.BOOLEAN_TYPE, default: false},
    // eslint-disable-next-line no-undefined
    exactActiveClass: {...PROP.STRING_TYPE, default: undefined},
    fab: {...PROP.BOOLEAN_TYPE, default: false},
    fixed: {...PROP.BOOLEAN_TYPE, default: false},
    flat: {...PROP.BOOLEAN_TYPE, default: false},
    // eslint-disable-next-line no-undefined
    href: {...PROP.STRING_TYPE, default: undefined},
    icon: {...PROP.BOOLEAN_TYPE, default: false},
    // eslint-disable-next-line no-undefined
    inputValue: {...PROP.STRING_TYPE, default: undefined},
    large: {...PROP.BOOLEAN_TYPE, default: false},
    left: {...PROP.BOOLEAN_TYPE, default: false},
    outlined: {...PROP.BOOLEAN_TYPE, default: false},
    plain: {...PROP.BOOLEAN_TYPE, default: false},
    replace: {...PROP.BOOLEAN_TYPE, default: false},
    right: {...PROP.BOOLEAN_TYPE, default: false},
    ripple: {...PROP.BOOLEAN_TYPE, default: false},
    rounded: {...PROP.BOOLEAN_TYPE, default: false},
    small: {...PROP.BOOLEAN_TYPE, default: false},
    tag: {...PROP.STRING_TYPE, default: 'button'},
    // eslint-disable-next-line no-undefined
    target: {...PROP.STRING_TYPE, default: undefined},
    // eslint-disable-next-line no-undefined
    to: {...PROP.STRING_TYPE, default: undefined},
    top: {...PROP.BOOLEAN_TYPE, default: false},
    type: {...PROP.STRING_TYPE, default: 'button'},
    // eslint-disable-next-line no-undefined
    width: {...PROP.STRING_TYPE, default: undefined},
    alwaysShow: {...PROP.BOOLEAN_TYPE, default: false},
  },
  methods: {
    handleClick() {
      if (this.onClick) {
        return this.onClick();
      }

      return null;
    },
  },
};
</script>

<template>
  <v-btn
    v-if="isVisible(null, false) || alwaysShow"
    data-test-id="handleClick"
    :absolute="absolute"
    :active-class="activeClass"
    :append="append"
    :block="block"
    :bottom="bottom"
    :color="color"
    :dark="dark"
    :depressed="depressed"
    :disabled="disabled"
    :exact="exact"
    :exact-active-class="exactActiveClass"
    :fab="fab"
    :fixed="fixed"
    :text="flat"
    :href="href"
    :icon="icon"
    :input-value="inputValue"
    :large="large"
    :left="left"
    :light="light"
    :loading="loading"
    :outlined="outlined"
    :plain="plain"
    :replace="replace"
    :right="right"
    :ripple="ripple"
    :rounded="rounded"
    :small="small"
    :tag="tag"
    :target="target"
    :to="to"
    :top="top"
    :type="type"
    :width="width"
    @click="handleClick"
    v-on="$listeners"
  >
    <slot>{{ text }}</slot>
  </v-btn>
</template>
